{
  "AUTOMATION": {
    "HEADER": "Tự động hoá",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Thêm luật Tự động hoá",
    "LOADING": "Đang lấy luật tự động hoá",
    "ADD": {
      "TITLE": "Thêm Quy tắc Tự động hoá",
      "SUBMIT": "Tạo",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "FORM": {
        "NAME": {
          "LABEL": "Tên luật",
          "PLACEHOLDER": "Nhập tên luật",
          "ERROR": "Cần phải có tên"
        },
        "DESC": {
          "LABEL": "Mô tả",
          "PLACEHOLDER": "Nhập mô tả luật",
          "ERROR": "Cần phải có \u001dmô tả"
        },
        "EVENT": {
          "LABEL": "Sự kiện",
          "PLACEHOLDER": "Vui lòng chọn một",
          "ERROR": "Cần phải có \u001dsự kiện"
        },
        "PHASE": {
          "LABEL": "Giai đoạn"
        },
        "ORDER": {
          "LABEL": "Thứ tự",
          "ERROR": "Cần có thứ tự"
        },
        "CONDITIONS": {
          "LABEL": "Điều kiện"
        },
        "ACTIONS": {
          "LABEL": "Hành động"
        }
      },
      "CONDITION_BUTTON_LABEL": "Thêm Điều kiện",
      "ACTION_BUTTON_LABEL": "Thêm Hành động",
      "API": {
        "SUCCESS_MESSAGE": "Luật tự động hoá thêm thành công",
        "ERROR_MESSAGE": "Không thể tạo luật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Giai đoạn",
        "ORDER": "Thứ tự",
        "NAME": "Tên",
        "DESCRIPTION": "Mô tả",
        "ACTIVE": "Có hiệu lực",
        "CREATED_ON": "Được tạo trên",
        "WAIT": "Chờ"
      },
      "404": "Không tìm thấy luật tự động hoá",
      "TABS": {
        "ALL": "Tất cả",
        "INSTANT": "Khi có sự kiện",
        "DELAYED": "Trì hoãn"
      },
      "WAITS": "Chờ {duration}"
    },
    "DELETE": {
      "TITLE": "Xoá luật Tự động hoá",
      "SUBMIT": "Xoá",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "CONFIRM": {
        "TITLE": "Xác nhận xoá",
        "MESSAGE": "Bạn có chắc muốn xoá ",
        "YES": "Có, xoá ",
        "NO": "Không, giữ "
      },
      "API": {
        "SUCCESS_MESSAGE": "Luật\u001d tự động hoá được xoá thành công",
        "ERROR_MESSAGE": "Không thể xoá luật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "EDIT": {
      "TITLE": "Sửa Luật Tự động hoá",
      "SUBMIT": "Cập nhật",
      "CANCEL_BUTTON_TEXT": "Huỷ",
      "API": {
        "SUCCESS_MESSAGE": "Luật\u001d tự động hoá được thêm thành công",
        "ERROR_MESSAGE": "Không thể cập nhật \bluật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "CLONE": {
      "TOOLTIP": "Nhân bản",
      "API": {
        "SUCCESS_MESSAGE": "Luật tự động hoá mô phỏng thành công",
        "ERROR_MESSAGE": "Không thể mô phỏng luật tự động hoá, Vui lòng thử lại sau"
      }
    },
    "FORM": {
      "EDIT": "Chỉnh sửa",
      "CREATE": "Tạo",
      "DELETE": "Xoá",
      "CANCEL": "Huỷ",
      "RESET_MESSAGE": "Thay đổi loại sự kiện sẽ đặt lại điều kiện và sự kiện mà bạn đã thêm bên dưới"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Bạn cần có ít nhất một điều kiện để lưu",
      "CONTACT_CUSTOM_ATTR_LABEL": "Thuộc tính Liên hệ Tùy chỉnh",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Tùy chỉnh Thuộc tính cuộc hội thoại"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Bạn cần có ít nhất một hành động để lưu",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Viết tin nhắn ở đây",
      "TEAM_DROPDOWN_PLACEHOLDER": "Chọn nhóm",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Chọn hộp thư đến email và địa chỉ gửi",
      "SUBJECT_INPUT_PLACEHOLDER": "Tiêu đề email",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Chọn hộp thư đến SMS để gửi SMS",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Nhập nội dung SMS",
      "SMS_COUNTER": "{length}/{limit} ký tự, {segments} SMS (trước khi điền các biến)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Kích hoạt Luật Tự động hoá",
      "DEACTIVATION_TITLE": "Vô hiệu hoá \bLuật Tự động hoá",
      "ACTIVATION_DESCRIPTION": "Thao tác này sẽ kích hoạt luật tự động hoá tên '{automationName}'. Bạn có chắc là muốn tiếp tục?",
      "DEACTIVATION_DESCRIPTION": "Thao tác này sẽ vô hiệu hoá luật tự động hoá tên '{automationName}'. Bạn có chắc là muốn tiếp tục?",
      "ACTIVATION_SUCCESFUL": "Luật tự động hoá đã được kích hoạt thành công",
      "DEACTIVATION_SUCCESFUL": "Luật tự động hoá đã vô hiệu hoá thành công",
      "ACTIVATION_ERROR": "Không thể kích hoạt luật tự động hoá, Vui lòng thử lại sau",
      "DEACTIVATION_ERROR": "Không thể vô hiệu hoá luật tự động hoá, Vui lòng thử lại sau",
      "CONFIRMATION_LABEL": "Có",
      "CANCEL_LABEL": "Không"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Không thể tải tập tin đính kèm, Vui lòng thử lại sau",
      "LABEL_IDLE": "Tải tập tin đính kèm",
      "LABEL_UPLOADING": "Đang tải lên...",
      "LABEL_UPLOADED": "Đã tải lên thành công",
      "LABEL_UPLOAD_FAILED": "Không tải lên được"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Giá trị bắt buộc có",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Hành động này chỉ hoạt động khi giai đoạn của luật được đặt là 'Trước khi gắn nhãn'.",
      "SKIP_AUTO_LABELING": "Hành động này chỉ hoạt động khi giai đoạn của luật được đặt là 'Trước khi gắn nhãn'.",
      "MOVE_CONVERSATION_TO_INBOX": "Chỉ các cuộc trò chuyện email và chat web mới có thể được chuyển sang hộp thư đến email, và chat web chỉ khi liên hệ có địa chỉ email. Nếu không, cuộc trò chuyện vẫn giữ nguyên vị trí và thay vào đó một lưu ý riêng sẽ được thêm vào.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Bắt đầu một cuộc trò chuyện mới với liên hệ trong hộp thư đến email đã chọn, gửi tin nhắn cho họ qua email và đánh dấu cuộc trò chuyện là đã giải quyết. Việc này xảy ra mỗi lần quy tắc chạy. Nếu liên hệ không có địa chỉ email, sẽ không có gì được gửi và thay vào đó một ghi chú riêng tư sẽ được thêm vào.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Bắt đầu một cuộc trò chuyện mới với liên hệ trong hộp thư đến SMS đã chọn, gửi tin nhắn cho họ dưới dạng SMS và đánh dấu cuộc trò chuyện là đã giải quyết. Việc này xảy ra mỗi lần quy tắc chạy. Tin nhắn là văn bản thuần túy, không có tệp đính kèm. Nếu liên hệ không có số điện thoại, sẽ không có gì được gửi và thay vào đó một ghi chú riêng tư sẽ được thêm vào."
    },
    "NOTICES": {
      "AI_PROMPT": "Mỗi lượt đánh giá riêng lẻ đều được tính phí.",
      "INCOMING_MESSAGES_COUNT": "Đây là số lượng tin nhắn đến trong cuộc trò chuyện.",
      "OUTGOING_MESSAGES_COUNT": "Đây là số lượng tin nhắn đi trong cuộc trò chuyện."
    },
    "PHASE": {
      "BEFORE_LABELING": "Trước khi gắn nhãn",
      "AFTER_LABELING": "Sau khi gắn nhãn"
    },
    "NONE_OPTION": "Không có",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Có",
      "NO": "Không"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Tin nhắn trực tiếp Instagram",
      "FACEBOOK_COMMENT": "Bình luận Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Đã tạo Cuộc trò chuyện",
      "CONVERSATION_UPDATED": "Đã cập nhật Cuộc trò chuyện",
      "MESSAGE_CREATED": "Đã tạo Tin nhắn",
      "CONVERSATION_OPENED": "Đã mở Cuộc trò chuyện",
      "CONVERSATION_RESOLVED": "Đã giải quyết Cuộc trò chuyện",
      "PHONE_CALL_FINISHED": "Đã kết thúc Cuộc gọi"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Gán cho Nhân viên",
      "ASSIGN_TEAM": "Gán một Nhóm",
      "ADD_LABEL": "Thêm một Nhãn",
      "REMOVE_LABEL": "Xoá một Nhãn",
      "SEND_EMAIL_TO_TEAM": "Gửi Email cho Nhóm",
      "SEND_EMAIL_TRANSCRIPT": "Gửi Bản ghi qua Email",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Gửi Bản ghi Email Chi tiết",
      "MUTE_CONVERSATION": "Tắt thông báo Cuộc trò chuyện",
      "SNOOZE_CONVERSATION": "Báo lại Cuộc trò chuyện",
      "RESOLVE_CONVERSATION": "Giải quyết Cuộc trò chuyện",
      "OPEN_CONVERSATION": "Mở Cuộc trò chuyện",
      "SEND_WEBHOOK_EVENT": "Gửi Sự kiện Webhook",
      "SEND_ATTACHMENT": "Gửi Tệp đính kèm",
      "SEND_MESSAGE": "Gửi một Tin nhắn",
      "ADD_NOTE": "Thêm một Ghi chú",
      "CHANGE_PRIORITY": "Thay đổi Độ ưu tiên",
      "ADD_SLA": "Thêm SLA",
      "SKIP_AUTO_PRIORITY": "Bỏ qua Độ ưu tiên Tự động",
      "SKIP_AUTO_LABELING": "Bỏ qua Gắn nhãn Tự động",
      "AUTO_TRANSLATE": "Dịch Tin nhắn",
      "AUTO_TRANSLATE_CONVERSATION": "Dịch Cuộc trò chuyện",
      "MOVE_CONVERSATION_TO_INBOX": "Chuyển cuộc trò chuyện sang hộp thư đến",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Gửi tin nhắn trong cuộc trò chuyện mới",
      "SEND_SMS_IN_NEW_CONVERSATION": "Gửi SMS trong cuộc trò chuyện mới",
      "STOP_PROCESSING_RULES": "Dừng Xử lý các Luật"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Bộ lọc AI",
      "MESSAGE_TYPE": "Loại tin nhắn",
      "MESSAGE_CONTAINS": "Nội dung tin nhắn",
      "EMAIL": "Email",
      "INBOX": "Hộp thư đến",
      "CHANNEL_TYPE": "Loại hộp thư đến",
      "CONVERSATION_LANGUAGE": "Ngôn ngữ cuộc trò chuyện",
      "PHONE_NUMBER": "Số điện thoại",
      "STATUS": "Trạng thái",
      "BROWSER_LANGUAGE": "Ngôn ngữ trình duyệt",
      "MAIL_SUBJECT": "Tiêu đề Email",
      "COUNTRY_NAME": "Quốc gia",
      "MARKETPLACE_COUNTRY": "Quốc gia của sàn thương mại điện tử",
      "REFERER_LINK": "Liên kết giới thiệu",
      "ASSIGNEE_NAME": "Người được gán",
      "TEAM_NAME": "Nhóm",
      "PRIORITY": "Độ ưu tiên",
      "CALL_DIRECTION": "Hướng cuộc gọi",
      "MISSED_CALL": "Cuộc gọi nhỡ",
      "MISSED_CALL_COUNT": "Số cuộc gọi nhỡ",
      "MESSAGE_SOURCE_TYPE": "Loại nguồn tin nhắn",
      "INCOMING_MESSAGE_COUNT": "Số tin nhắn đến",
      "OUTGOING_MESSAGE_COUNT": "Số tin nhắn đi",
      "LABEL": "Nhãn",
      "EMAIL_RECIPIENTS": "Người nhận Email",
      "EMAIL_AUTO_REPLY": "Email là phản hồi tự động",
      "ATTACHMENT_EXTENSION": "Phần mở rộng tệp đính kèm",
      "EXTENSION": "Số nội bộ được gọi",
      "WORKING_HOURS": "Trong giờ làm việc",
      "AGENT_REPLIED": "Nhân viên đã trả lời kể từ khi đổi trạng thái"
    },
    "WAIT": {
      "RUN_LABEL": "Chạy các hành động",
      "INSTANT": "Khi có sự kiện",
      "DELAYED": "Trì hoãn",
      "TRIGGER_LABEL": "Chờ cho đến khi",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Cuộc hội thoại giữ nguyên một trạng thái",
        "CUSTOMER_UNRESPONSIVE": "Khách hàng không trả lời nhân viên",
        "AGENT_UNRESPONSIVE": "Khách hàng không nhận được phản hồi của nhân viên"
      },
      "STATUS_LABEL": "Trạng thái",
      "STATUSES": {
        "OPEN": "Mở",
        "PENDING": "Chờ giải quyết",
        "SNOOZED": "Tạm dừng",
        "RESOLVED": "Đã được giải quyết"
      },
      "DELAY_LABEL": "Thời gian chờ",
      "DELAY_ERROR": "Nhập thời gian chờ từ 1 phút đến 30 ngày",
      "DURATION": {
        "MINUTES": "{count} phút",
        "HOURS": "{count} giờ",
        "DAYS": "{count} ngày"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Các hành động chạy khi cuộc hội thoại ở trạng thái {status} trong {duration}. Thay đổi trạng thái trước thời điểm đó sẽ hủy chúng. Nhãn, giờ làm việc và phản hồi của nhân viên được kiểm tra khi hết thời gian chờ.",
        "CUSTOMER_UNRESPONSIVE": "Các hành động chạy khi khách hàng không trả lời trong {duration} sau tin nhắn của nhân viên. Phản hồi của khách hàng sẽ hủy chúng; tin nhắn mới của nhân viên bắt đầu lại thời gian chờ.",
        "AGENT_UNRESPONSIVE": "Các hành động chạy khi khách hàng đã chờ {duration} mà không có phản hồi của nhân viên. Phản hồi của nhân viên sẽ hủy chúng."
      }
    }
  }
}
